import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { Unit } from '../../common/models/Unit.Model';
import { ReportsService } from '../reports.service';
import { SettingsService } from '../../../core/settings/settings.service';
import { GlobalFunctionsService } from '../../common/functions/global-functions.service';
import { CalendarService } from '../../configuration/calendar/calendar.service';
import { AdjustService } from '../../inventory/adjust/adjust.service';
import { Calendar } from '../../common/models/Calendar.Model';

@Component({
  selector: 'app-rep-balance',
  templateUrl: './rep-balance.component.html',
  styleUrls: ['./rep-balance.component.scss']
})
export class RepBalanceComponent implements OnInit {

  public downloading: boolean = false;
  
  // Listas
  public organizacionList: Unit[] = [];
  public origenList: any[] = [];
  public destinoList: any[] = [];
  
  // Valores seleccionados
  public orgSelectedOri: number;
  public orgSelectedDes: number;
  public Ori: number;
  public Dest: number;

  constructor(
    private router: Router,
    private calendarService: CalendarService,
    private reportService: ReportsService, 
    private settings: SettingsService,
    private globalFunctionService: GlobalFunctionsService,
    private adjustService: AdjustService
  ) { }

  async ngOnInit() {
    this.globalFunctionService.canOperate();
    this.globalFunctionService.hasFSBRPending();

    // Validaciones de Inventario y Ajuste
    await this.validateStatus();

    this.getOrganizacion();
  }

  private async validateStatus() {
    this.calendarService.CalendarInventoryInProgress().subscribe((calendar: Calendar[]) => { 
      if (calendar.length === 1) { 
        this.globalFunctionService.messageToast(`No es posible realizar esta operación, se encuentra en toma de inventario físico.`, 'warning');
        this.router.navigate([`/home`]);
      }
    });

    const userUnitId = this.settings.getUser().UnitId;
    const adjustResp = await this.adjustService.validateAdjustActive(userUnitId).toPromise();
    if (adjustResp && adjustResp.AdjustCode !== '') {
      this.globalFunctionService.messageToast(`No es posible realizar esta operación, se encuentra en compulsa.`, 'warning');
      this.router.navigate([`/home`]);
    }
  }

  getOrganizacion(): void {
    const user = JSON.parse(localStorage.getItem("user") || '{}');
    const userId = user.Id || 0;
    const org = user.Org || 1;

    this.reportService.getOrganizacionesByUser(org, userId).subscribe((regiones: Unit[]) => {
      this.organizacionList = regiones;
      if (regiones.length > 0) {
        this.orgSelectedOri = regiones[0].UnitId;
        this.orgSelectedDes = regiones[0].UnitId;
        this.changeFilterOrgOri();
        this.changeFilterOrgDes();
      }
    });
  }

  changeFilterOrgOri() {
    const user = JSON.parse(localStorage.getItem("user") || '{}');
    this.reportService.getUserNodes(user.Org, user.Id, this.orgSelectedOri.toString()).subscribe((move: any[]) => {
      this.origenList = move;
      if (move.length > 0) this.Ori = move[0].UnitId;
    });
  }

  changeFilterOrgDes() {
    const user = JSON.parse(localStorage.getItem("user") || '{}');
    this.reportService.getUserNodes(user.Org, user.Id, this.orgSelectedDes.toString()).subscribe((move: any[]) => {
      this.destinoList = move;
      if (move.length > 0) this.Dest = move[0].UnitId;
    });
  }

  download() {
    if (this.Ori == null || this.Dest == null) {
      this.globalFunctionService.messageToast(`Por favor capture los filtros faltantes.`, 'warning');
      return;
    }

    this.downloading = true;
    this.reportService.getRepSaldosExcel(
      this.Ori.toString(), 
      this.Dest.toString(), 
      this.orgSelectedOri.toString(), 
      this.orgSelectedDes.toString()
    ).subscribe({
      next: (resp: any) => {
        if (!resp) {
          this.downloading = false;
          this.globalFunctionService.messageToast(`No se ha encontrado información.`, 'warning');
          return;
        }
        
        const blob = new Blob([resp], { type: resp.type });
        const anchor = document.createElement('a');
        anchor.download = `CEQ-ReporteFlujos.xlsx`;
        anchor.href = window.URL.createObjectURL(blob);
        anchor.click();
        this.downloading = false;
      },
      error: (err) => {
        this.downloading = false;
        this.globalFunctionService.messageToast(`Error en la invocación`, 'warning');
        console.error(err);
      }
    });
  }
}